import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  invalidateChatTokenForMutualFollow,
  invalidateSocialGraph,
} from "Api/Mutations/Social/invalidateSocialGraph";
import {
  type ApproveFollowRequestResult,
  postSocialFollowRequestsRequesterIdentityUserPublicIDApprove,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";
import { Resources, useResource } from "Translations/Resources";
import { toast } from "sonner";

/**
 * Approves a pending follow request addressed to the caller. When the caller already follows the
 * requester this makes them mutual followers — confirm that first (useMutualFollowConfirm).
 */
export const useApproveFollowRequestMutation = () => {
  const queryClient = useQueryClient();
  const { t } = useResource();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails(
      (requesterIdentityUserPublicID: string) =>
        postSocialFollowRequestsRequesterIdentityUserPublicIDApprove(
          requesterIdentityUserPublicID,
        ),
    ),
    onSuccess: ({ isMutual }: ApproveFollowRequestResult) => {
      invalidateSocialGraph(queryClient);
      if (isMutual) {
        invalidateChatTokenForMutualFollow(queryClient);
      }
    },
    onError: () => toast.error(t(Resources.Errors.RequestError)),
  });
};
